import { useInfiniteQuery } from "@tanstack/react-query";
import { QUERY_KEYS } from "app/data/common/queryKeys";
import inboundChangeLogService from "app/data/inbound-freight/inboundChangeLogService";
import { InboundChangeLogFilterParams } from "app/data/inbound-freight/inboundChangeLogModels";

export const useInboundChangeLog = (
  filter: InboundChangeLogFilterParams = {},
  enabled = true
) => {
  const { dateFrom, dateTo, actionType, search, manifestNumber, terminalNumber } = filter;

  return useInfiniteQuery({
    queryKey: [
      QUERY_KEYS.INBOUND_CHANGE_LOG,
      "search",
      actionType,
      search,
      manifestNumber,
      terminalNumber,
      dateFrom,
      dateTo,
    ],
    queryFn: async ({ pageParam = 0 }) => {
      return inboundChangeLogService.search(
        {
          dateFrom,
          dateTo,
          actionType,
          search,
          manifestNumber,
          terminalNumber,
        },
        pageParam
      );
    },
    getNextPageParam: (lastPage) => {
      if (lastPage?.last) return undefined;
      return (lastPage?.pageable?.pageNumber ?? 0) + 1;
    },
    enabled,
    keepPreviousData: false,
    refetchOnWindowFocus: false,
    retry: false,
  });
};
